import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTapTipGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 42,
	viewBox: "0 0 35 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3070_354",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 35,
			height: 42,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 35,
				height: 42,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_3070_354)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M33.1516 34.238C33.4275 35.0047 33.1018 35.8433 32.4413 36.2626L24.4985 40.7224C23.1854 41.4353 21.5211 41.1957 20.4802 40.0494C14.8213 34.3147 13.3622 35.995 9.98672 32.8772C7.64117 30.7127 5.32362 28.4368 2.52164 26.9164C0.893759 26.1848 2.15825 24.27 3.4077 23.9072C4.53343 23.5763 5.60948 23.8353 6.60725 24.1961C7.22688 24.3676 9.72791 26.2596 10.9062 26.9574C11.9222 27.5624 12.2646 26.6077 12.3561 25.4277C11.3782 19.7589 8.74938 14.4265 7.06331 8.86519C6.66751 7.77512 7.07501 6.78069 8.05162 6.29485C9.01503 5.87109 10.127 6.25881 10.6624 7.25095C11.4186 8.64584 12.1233 10.0288 12.8759 11.4769C13.7988 13.2675 14.8094 15.1725 15.7483 16.9652C19.1528 16.5125 22.6713 16.7904 26.0992 17.5979C27.9659 18.0583 29.5089 18.6181 30.3953 20.3038C30.9024 21.2428 31.1966 22.6702 31.4467 23.8988C31.8524 25.9077 32.0094 27.8922 32.1224 29.991C32.3152 31.7786 32.6218 32.8142 33.1516 34.238Z",
				fill: "url(#paint0_linear_3070_354)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M5.25005 13.7548C2.75747 12.0775 1.6684 8.84196 2.80642 5.92638C4.12426 2.55009 7.92961 0.881394 11.3059 2.19924C14.254 3.34996 15.9002 6.39727 15.3929 9.39945",
				stroke: "#7FE718",
				strokeWidth: 1.75,
				strokeLinecap: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3070_354",
			x1: 17.5,
			y1: 6.125,
			x2: 17.5,
			y2: 41.125,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .1
			})]
		}) })
	]
});
export default SvgTapTipGreen;
